import React, { useEffect, useCallback } from 'react';
import { bool, func, node, object, objectOf, oneOfType, shape, string } from 'prop-types';

import { noop } from '@ajaibid/utils';
import { Input } from '@ajaibid/components';
import useField from './hooks/useField';

const FormCheckbox = (props) => {
  const {
    id,
    name,
    defaultValue,
    error: propsError,
    onChange,
    onError,
    onValid,
    validators,
    ...baseProps
  } = props;

  const [
    fieldValue = false,
    { updateField, updateForm, error: errorMessage, errorKey, showError },
  ] = useField(name, { defaultValue, validators });

  const onChangeCb = useCallback((params) => onChange(params), [onChange]);
  const onErrorCb = useCallback((params) => onError(params), [onError]);
  const onValidCb = useCallback((params) => onValid(params), [onValid]);

  useEffect(() => {
    if (errorMessage) {
      onErrorCb({ errorMessage, errorKey });
    } else {
      onValidCb();
    }
  }, [errorMessage, errorKey, onErrorCb, onValidCb]);

  // TODO: this line breaks validator. Wait for QA regression, if it works fine without it, remove
  // useEffect(() => {
  //   if (propsError) {
  //     updateForm(name, fieldValue, propsError);
  //   }
  // }, [propsError, name, updateForm]);

  const handleChange = () => {
    onChangeCb(!fieldValue);
    updateField(!fieldValue);
  };

  return (
    <Input.Checkbox
      id={id}
      name={name}
      value={fieldValue}
      onChange={handleChange}
      // Only pass the error message when Form showError is true.
      error={showError ? propsError || errorMessage || '' : ''}
      {...baseProps}
    />
  );
};

FormCheckbox.propTypes = {
  // <Input.Checkbox> props
  id: string.isRequired,
  name: string.isRequired,
  children: oneOfType([node, string]),
  className: string,
  disabled: bool,
  style: object,
  // <Form.Checkbox> props
  defaultValue: bool,
  error: string,
  onChange: func,
  onError: func,
  onValid: func,
  validators: objectOf(
    shape({
      validator: func,
      message: string,
    })
  ),
};

FormCheckbox.defaultProps = {
  // <Input.Checkbox> props
  children: null,
  className: '',
  disabled: false,
  style: {},
  // <Form.Checkbox> props
  defaultValue: false,
  error: '',
  onChange: noop,
  onError: noop,
  onValid: noop,
  validators: {},
};

export default FormCheckbox;
